<template>
  <VDataGridV2
    ref="data-grid"
    :loader="loader"
    :context-menu="TradeMarksService.contextMenu"
    sticky
    paginated
    entity-type="tradeMark"
    @row:dblclick="openCard"
  >
    <VDataGridColumnV2
      id="id"
      label="id"
      width="50px"
    >
      <template #default="{ row }">
        <VLink
          @click="openCard(row)"
        >
          {{ row.id }}
        </VLink>

        <VBadge
          v-if="row.isDeleted"
          class="warning"
        >
          Удалена
        </VBadge>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="name"
      label="Название"
      width="500px"
      :filter="$core.filters.pattern"
      content-class="nowrap ellipsis"
    >
      <template #default="{ row }">
        {{ row.name }}
      </template>
    </VDataGridColumnV2>
  </VDataGridV2>
</template>

<script lang="ts">

import DataGridLoader       from '@/lib/components/VDataGridV2/DataGridLoader';
import TradeMark            from '@/domains/TradeMarks/TradeMark';
import TradeMarksService    from '@/domains/TradeMarks/TradeMarksService';

export default defineComponent({
  name: 'TradeMarksRegistry',

  data() {
    return {
      TradeMarksService,
      loader: new DataGridLoader(TradeMarksService.getListPaginated),
    };
  },

  methods: {
    async openCard(row: TradeMark): Promise<void> {
      if (await TradeMarksService.showCard(row)) {
        this.loader.refresh();
      }
    },
  },
});
</script>
